import DashboardFiltersMobileContainer from './containers/DashboardFiltersMobileContainer';

export default DashboardFiltersMobileContainer;
